<template>
  <div class="sticky-menu navbar-absolute top-navbar element-background-color">
    <div class="d-none d-xl-block">
      <nav class="navbar navbar-expand-xl navbar-dark container" style="align-items: center; background: transparent;">
        <NuxtLink class="navbar-brand custom-logo mb-0" rel="home" to="/#start" title="DATENBANKGESTALTER.DE">
          <img src="/img/mydb_logo.png">
        </NuxtLink>

        <ul v-if="withNavItems" class="navbar-nav align-items-center mb-0">
          <li class="nav-item">
            <NuxtLink class="nav-link" to="/#start">{{ $t('headerNav.start') }}</NuxtLink>
          </li>
          <span class="nav-link no-pointer px-1">|</span>
          <li class="nav-item">
            <NuxtLink class="nav-link" to="/#nutzen">{{ $t('headerNav.benefit') }}</NuxtLink>
          </li>
          <span class="nav-link no-pointer px-1">|</span>
          <li class="nav-item">
            <NuxtLink class="nav-link" to="/#datenbanken">{{ $t('headerNav.content') }}</NuxtLink>
          </li>
          <span class="nav-link no-pointer px-1">|</span>
          <li class="nav-item">
            <NuxtLink class="nav-link" to="/#einzelpersonen">{{ $t('headerNav.agents') }}</NuxtLink>
          </li>
          <span class="nav-link no-pointer px-1">|</span>
          <li class="nav-item">
            <NuxtLink class="nav-link" to="/#unternehmen">{{ $t('headerNav.companies') }}</NuxtLink>
          </li>
          <span class="nav-link no-pointer px-1">|</span>
          <li class="nav-item">
            <NuxtLink class="nav-link" to="/#geschichte">{{ $t('headerNav.history') }}</NuxtLink>
          </li>
        </ul>

        <div v-if="withNavItems" class="ms-auto d-flex align-items-center">
          <BaseButton v-if="!loggedIn" type="primary" size="sm" @click="$emit('login')">Anmelden</BaseButton>
          <AccountIcon v-else />
        </div>
      </nav>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  withNavItems: {
    type: Boolean,
    default: true
  },
  loggedIn: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['login']);
</script>

<style></style>
